<template>
  <div class="userinfo">
    <div class="headers"><span>{{ $t('menu.account') }}</span></div>
    <div class="userInfoPage">
      <a-form-model ref="ruleForm" layout="vertical">
        <a-form-model-item :label="$t('base.userName')">
          <div class="fromItem">
            <span>{{ userDetail.userName }}</span>
            <div class="setBtnClass" @click="showUserName">{{ $t('base.setting') }}</div>
          </div>
        </a-form-model-item>
        <a-divider></a-divider>
        <a-form-model-item :label="$t('base.avatar')">
          <div class="fromItem">
            <div class="userIconSetting">
              <img
                v-if="userDetail.icon"
                style="width: 30px; height: 30px; border-radius: 50%"
                alt="avatar"
                :src="userDetail.icon"
              />
              <div v-else class="iconClass"></div>
              <span class="textTip">{{$t('base.supportedImageFormat')}}</span>
            </div>
            <div class="setBtnClass">
              <a-upload
                :action="uploadImgUrl"
                :showUploadList="false"
                :multiple="false"
                accept="image/png, image/jpeg"
                @change="onChange"
                :headers="{ Authorization: token }"
              >
                <div class="setBtnListClass">{{ $t('base.modify') }}</div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>
        <a-divider></a-divider>
        <a-form-model-item :label="$t('base.phone')">
          <div class="fromItem">
            <span>{{ userDetail.phone }}</span>
            <div class="setBtnClass" @click="settingUserPhone">{{ $t('base.modify') }}</div>

          </div>
        </a-form-model-item>
        <a-divider></a-divider>
        <a-form-model-item :label="$t('base.companyName')">
          <div class="fromItem">
            <span>{{ userDetail.company }}</span>
            <div class="setBtnClass" @click="settingUserCompany">{{ $t('base.modify') }}</div>
          </div>
        </a-form-model-item>
        <a-divider></a-divider>
        <a-form-model-item :label="$t('base.loginPassword')">
          <div class="fromItem">
            <span>************</span>
            <div class="setBtnClass" @click="settingUserPassword">{{ $t('base.modify') }}</div>
          </div>
        </a-form-model-item>
        <a-divider></a-divider>
        <a-form-model-item :label="$t('base.thirdPartyBinding')">
          <div class="thirdPartyBinding">
            <!-- <div class="thirdFromItem">
              <div class="thirdIcon">
                <div class="scan-wx"></div>
                <span>{{ userDetail.wxBinding == 0 ? '已绑定' : '未绑定' }} </span>
              </div>
              <div class="setBtnClass" v-if="userDetail.wxBinding == 0" @click="unBindUserwx">解绑</div>
            </div> -->
            <div class="thirdFromItem">
              <div class="thirdIcon">
                <div class="scan-jjt"></div>
                <span>{{ $t('base.isBinding') }}</span>
              </div>
              <!-- <div class="setBtnClass">解绑</div> -->
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <settingUserName
      v-if="showUserNameSetting"
      @closeSettingUserNameModal="closeSettingUserNameModal"
      @refreshDetail="refreshDetail"
      :userId="userId"
      :userName="userName"
    ></settingUserName>
    <settingPhone
      v-if="showUserPhoneSetting"
      @closeSettingPhoneModal="closeSettingPhoneModal"
      @refreshDetail="refreshDetailSettingPhone"
      :userId="userId"
      :phone="phone"
    ></settingPhone>
    <settingCompany
      v-if="showUserCompanySetting"
      @closeSettingPhoneModal="closeSettingCompanyModal"
      @refreshDetail="refreshDetailSettingCompanyModal"
      :userId="userId"
      :company="company"
    ></settingCompany>
    <settingPassword
      v-if="showUserPasswordSetting"
      @closeSettingPhoneModal="closePasswordSetting"
      @refreshDetail="refreshDetailPasswordSetting"
      :userId="userId"
    ></settingPassword>
  </div>
</template>

<script>
import request from '@/utils/request'
import base from '@/api/base'
import store from '@/store'
import { getDetailApi, postCompanyList, getUserUpdate, wxUnbindApi } from '@/api/user'
import { checkLogin } from '@/utils/authCenter'
import { setUserInfo } from '@/api/micro'
import { getToken } from '@/utils/auth'
import settingUserName from './components/setting-userName/index.vue'
import settingPhone from './components/settingPhone/index.vue'
import settingCompany from './components/settingCompany/index.vue'
import settingPassword from './components/setting-password/index.vue'
const uploadImgUrl = `${base.api}/micro/file/zos/upload`
export default {
  components: {
    settingUserName,
    settingPhone,
    settingCompany,
    settingPassword,
  },
  data() {
    return {
      userDetail: {},
      oldData: {},
      companyList: [], //公司列表
      companyName: '', // 公司名称
      isName: false,
      isNickname: false,
      showUserNameSetting: false,
      showUserPhoneSetting: false,
      showUserCompanySetting: false,
      showUserPasswordSetting: false,
      uploadImgUrl,
      imageIcon: '',
      userName: '',
      phone: '',
      company: '',
      userId: '',
      token: getToken(),
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {},
  created() {
    this.getUserInfo()
  },
  mounted() {},
  methods: {
    onChange(currentFile) {
      if (currentFile.file.status === 'done') {
        this.userDetail.icon = currentFile.file.response.data.fileFullPath
        let data = {
          icon: this.userDetail.icon,
          account: this.userId,
        }
        getUserUpdate(data).then((res) => {
          if (res.code === 200) {
            this.getUserInfo()
            this.$message.success(this.$t('tip.avatarChangeSuccess'))
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    //上传图片
    handleChangeUpload(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        console.log('info.file: ', info.file)
        const { data, status, message } = info.file?.response
        if (!status) {
          this.loading = false
          setUserInfo({
            imageUrl: data.downloadPath,
          })
            .then((res) => {
              if (!res.status) {
                this.getUserInfo()
                this.$message.success('更新成功')
              } else {
                this.$message.error(res.message || '上传失败')
              }
            })
            .catch((err) => {
              this.$message.error(err.message || '上传失败')
            })
        } else {
          this.$message.error(message || '上传失败')
        }
        // Get this url from response in real world.
      }
    },
    //上传之前
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp' ||
        file.type === 'image/x-icon' ||
        file.type === 'image/webp'

      if (!isJpgOrPng) {
        this.$message.error('当前图片格式不支持!')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片不能大于10MB!')
      }
      return isJpgOrPng && isLt10M
    },
    goTab(item, ind) {
      this.activeMenuIndex = ind
      if (item.path == 'message') {
        this.$router.push({ path: `user-info/message/${null}` })
      } else {
        this.$router.push({ path: '/user-info/' + item.path })
      }
    },
    upgrade() {
      this.$router.push('/user-info/member')
    },
    // 设置用户名
    showUserName() {
      this.userName = this.userDetail.userName
      this.showUserNameSetting = true
    },
    // 设置手机号
    settingUserPhone() {
      this.phone = this.userDetail.phone
      this.showUserPhoneSetting = true
    },
    // 设置企业
    settingUserCompany() {
      this.company = this.userDetail.company
      this.showUserCompanySetting = true
    },
    // 设置密码
    settingUserPassword() {
      this.showUserPasswordSetting = true
    },
    // 微信解绑
    unBindUserwx() {
      const vm = this
      this.$confirm({
        title: '确认解除绑定微信账户?',
        content: '解除绑定后，你将无法使用微信扫码登录',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          const data = {
            account: vm.userId,
          }
          wxUnbindApi(data).then((res) => {
            if (res.code === 200) {
              vm.$message.success('解绑成功！')
              vm.getUserInfo()
            } else {
              vm.$message.error(res.message)
            }
          })
        },
      })
    },
    // 关闭设置用户名弹窗
    closeSettingUserNameModal() {
      this.showUserNameSetting = false
    },
    // 关闭设置手机号弹窗
    closeSettingPhoneModal() {
      this.showUserPhoneSetting = false
    },
    // 关闭设置企业弹窗
    closeSettingCompanyModal() {
      this.showUserCompanySetting = false
    },
    // 关闭设置密码弹窗
    closePasswordSetting() {
      this.showUserPasswordSetting = false
    },
    // 刷新
    refreshDetailPasswordSetting() {
      this.showUserPasswordSetting = false
      this.getUserInfo()
    },
    // 刷新
    refreshDetailSettingPhone() {
      this.showUserPhoneSetting = false
      this.getUserInfo()
    },
    // 刷新
    refreshDetailSettingCompanyModal() {
      this.showUserCompanySetting = false
      this.getUserInfo()
    },
    // 刷新
    refreshDetail() {
      this.showUserNameSetting = false
      this.getUserInfo()
    },
    // 验证昵称长度
    checkNickname() {
      if (this.data.nickname.length > 10) {
        this.$message.error('昵称字数只能少于10个字!')
        this.isNickname = true
      } else {
        this.isNickname = false
      }
    },
    // 验证姓名长度
    checkName() {
      if (this.data.name.length > 10) {
        this.$message.error('姓名字数只能少于10个字!')
        this.isName = true
      } else {
        this.isName = false
      }
    },
    // 获取公司
    __postCompanyList() {
      const data = {
        keyWord: '',
      }
      postCompanyList(data).then((res) => {
        // console.log(res.data)
        this.companyList = res.data
      })
    },
    // 选择公司
    handleChange(value) {
      console.log(value)

      const arr = this.companyList.filter((item) => item.companyCode == value)
      console.log(arr)
      this.data.companyName = arr[0].companyName
      this.data.companyCode = arr[0].companyCode
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    //复制
    copyUserId() {
      var input = document.createElement('input') // js创建一个input输入框
      input.value = this.data.userId // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input) // 将输入框暂时创建到实例里面
      input.select() // 选中输入框中的内容
      document.execCommand('Copy') // 执行复制操作
      document.body.removeChild(input) // 最后删除实例中临时创建的input输入框，完成复制操作
      this.$message.success(this.$t('tip.copySuccess'))
    },
    getUserInfo() {
      this.userId = this.userInfo.userId
      getDetailApi({ account: this.userId })
        .then((res) => {
          const { data } = res
          this.$store.dispatch('user/getUserDetail', this.userId)
          this.userDetail = data
        })
        .catch(() => {})
    },
    //文件图片样式
    errorImg(item) {
      if ((item.headshot ?? '') === '') {
      } else {
        return this.jointPath(item.headshot)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.userinfo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .headers {
    font-size: 18px;
    font-weight: bold;
    height: 60px;
    display: flex;
    align-items: center;
    padding-left: 2%;
    color: #ffffff;
  }
  .userInfoPage {
    width: 540px;
    display: flex;
    flex-direction: column;
    color: #ffffff;
    display: flex;
    margin-top: 80px;
    /deep/ .ant-form-item{
      margin-bottom: 12px;
    }
    .fromItem {
      width: 100%;
      height: 30px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #bababb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #fff;
      }
      .userIconSetting {
        display: flex;
        align-items: center;
      }
      .setBtnClass {
        width: 60px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2e2e2e;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;
      }
    }
  }
}

/deep/ .ant-input {
  width: 440px;
}

/deep/ .ant-select-selection {
  width: 440px;
}
/deep/ .ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.textTip {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #8b8b8d;
  margin-left: 10px;
}

.thirdPartyBinding {
  width: 100%;
  color: #bababb;

  .thirdFromItem {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .setBtnClass {
      width: 60px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #2e2e2e;
      border-radius: 4px 4px 4px 4px;
      cursor: pointer;
    }

    .thirdIcon {
      display: flex;
      font-size: 12px;
      height: 40px;
      align-items: center;

      .scan-wx {
        width: 32px;
        height: 32px;
        background-image: url('../../assets/images/wx-login.png');
        background-size: 100% 100%;
        cursor: pointer;
        margin-right: 16px;
      }

      .scan-jjt {
        width: 32px;
        height: 32px;
        background-image: url('../../assets/images/jjt-login.png');
        background-size: 100% 100%;
        cursor: pointer;
        margin-right: 16px;
      }
    }
  }
}

.iconClass {
  width: 42px;
  height: 42px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('./../../assets/images/default-avatar.png');
}
.setBtnListClass {
  color: #bababb;
  font-size: 16px;
}
</style>
